import RecibeFormConfig from "./form";
import GenericForm from "../GenericForm";
import { RecibeFormData } from "@/formTypes/RecibeDataType";
import { RecibeApi, RecibeDataType } from "@/api/RecibeApi";
import { useEffect, useRef, useState } from "react";
import { getDefaultCurrency } from "@utils/Currency";
import { DynamicFormRef } from "@mavichpe/dynamic-forms";
import { ClientApi } from "@/api/ClientApi";
import { CurrencyIdPubSub } from "@utils/pubsubs/PubSub";

type RecibeFormProps = {
  id?: string;
  formId: string,
  saveRedirectUrl: string
}

const RecibeForm = (props: RecibeFormProps) => {
  const [defaultData, setDefaultData] = useState<RecibeDataType>({});
  const formRef = useRef<DynamicFormRef>(null);


  useEffect(() => {
    const run = async () => {
      const defaultCurrency = await getDefaultCurrency()
      if (defaultCurrency.id) {
        setDefaultData({ currencyId: defaultCurrency.id })
        CurrencyIdPubSub.publish({ currencyId: defaultCurrency.id })
      }
    }
    run();
  }, []);

  const onInputChange = async (name: keyof RecibeDataType, value: any) => {
    if (name == "clientId") {
      const clientData = await ClientApi.get(value);
      formRef.current?.setFormValue("nombre", `${clientData.nombre}`, "String");
    }
  }

  return (
    <GenericForm<RecibeFormData, RecibeDataType>
      id={props.id}
      ref={formRef}
      formId={props.formId}
      defaultData={defaultData}
      saveRedirectUrl={props.saveRedirectUrl}
      onInputChange={onInputChange}
      formConfig={RecibeFormConfig}
      getById={(...arg) => RecibeApi.get(...arg)}
      createFn={(...arg) => RecibeApi.create(...arg)}
      updateFn={(...arg) => RecibeApi.update(...arg)}
      successMessage="El Recibo ha sido almacenada correctamente"
      errorMessage="No fue posible almacenar la información del Recibo"
    />
  )
}

export default RecibeForm;